var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"visible":_vm.visible,"footer":null,"centered":""},on:{"cancel":function($event){return _vm.$emit('cancel')}}},[_c('div',[_c('LoginForm',{on:{"wxlogin":(e) => _vm.getWXInfo(e)}}),_c('MobileForm'),_c('QrcodeForm'),_c('BindForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }